import React, { useContext, useState, useEffect } from 'react';
import {
  Modal,
  Form,
  Typography,
  Row,
  Col,
  Divider,
  Avatar,
  InputNumber,
  Button,
  Result,
} from 'antd';
import { EuroCircleOutlined } from '@ant-design/icons';
import { useIntl } from 'react-intl';
import { StoreContext } from '../store/index';
import { fetchUsers, addTokens } from './api';
import { getDateFromTimestamp } from '../utils';
import PlayersList from '../components/PlayersList';

function AddTokensModal({ visible, onClose, onConfirm }) {
  const store = useContext(StoreContext);
  const {
    user: [user, setUser, setUpdateUser],
    isUserLoading: [isUserLoading, setIsUserLoading],
  } = store;
  const { formatMessage } = useIntl();
  const { Text } = Typography;

  const [form] = Form.useForm();

  const [loading, setLoading] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [selectedPlayer, setSelectedPlayer] = useState(null);
  const [users, setUsers] = useState([]);
  const [tokensValue, setTokensValue] = useState(50);

  const onFinish = async values => {
    onConfirm();
    onClose();
  };
  const onFinishFailed = values => {};

  useEffect(() => {
    fetchUsers(setLoading).then(data => {
      setUsers(data);
    });
  }, []);

  const handleAddTokens = () => {
    addTokens(
      selectedPlayer.id,
      {
        ...selectedPlayer,
        tokens:
          selectedPlayer.tokens !== undefined
            ? selectedPlayer.tokens + tokensValue
            : tokensValue,
      },
      setLoading,
    ).then(data => {
      if (data) {
        setShowResult(true);
      }
      setUpdateUser(true);
      setSelectedPlayer(null);
      fetchUsers(setLoading).then(d => {
        setUsers(d);
      });
    });
  };

  return (
    <Modal
      title={formatMessage({ id: 'shifts.actions.pay' })}
      open={visible}
      onCancel={onClose}>
      <PlayersList
        header={formatMessage({ id: 'admin.panel.add.tokens.users' })}
        dataSource={users}
        selectPlayer={setSelectedPlayer}
      />
      {selectedPlayer && !loading && !isUserLoading && (
        <>
          <Divider />
          <Row justify="center">
            <Typography.Text strong>{selectedPlayer.nickname}</Typography.Text>
          </Row>
          <Row justify="center" style={{ marginTop: '8px' }}>
            <Avatar size={100} src={selectedPlayer.photoURL} />
          </Row>
          <Row justify="center" style={{ marginTop: '8px' }}>
            <Typography.Text strong>{selectedPlayer.email}</Typography.Text>
          </Row>
          <Row justify="center">
            <EuroCircleOutlined
              style={{ fontSize: '18px', marginRight: '2px' }}
            />
            <Typography.Text>{`${selectedPlayer.tokens || 0}`}</Typography.Text>
          </Row>
          <Divider />
          <Row
            justify="center"
            style={{ margin: '4px 0px', paddingRight: '16px' }}>
            <Col xs={4} offset={2}>
              <InputNumber
                max={200}
                onChange={v => setTokensValue(v)}
                value={tokensValue}
              />
            </Col>
            <Col xs={14} offset={2}>
              <Button
                className="width100"
                type="primary"
                loading={loading}
                onClick={handleAddTokens}>
                {formatMessage({ id: 'admin.panel.add.tokens.button' })}
              </Button>
            </Col>
          </Row>
        </>
      )}
      {showResult && !selectedPlayer && (
        <Result
          status="success"
          title={formatMessage({
            id: 'admin.panel.add.tokens.success.title',
          })}
          subTitle={formatMessage({
            id: 'admin.panel.add.tokens.success.subtitle',
          })}
        />
      )}
    </Modal>
  );
}

export default AddTokensModal;
